import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from 'src/services/api'
import { API_URL } from 'src/services/api/constant'
import { CHECK_IN } from 'src/store/slice/checkIn/type'
import { createOrderFailed } from 'src/store/slice/payment'
import addNotification, { NOTIFICATION_TYPE } from 'src/utils/toast'

export const apiGetTickets = (params) => {
  return api.get(API_URL.TICKET.GET_TICKETS, params)
}

/** start payment */
export const apiCheckIn = (params) => {
  return api.get(API_URL.TICKET.CHECK_IN, params)
}

function* doCheckIn({ payload }) {
  try {
    const response = yield call(apiCheckIn, payload.body)
    if (response?.statusCode === 200) {
      if (payload.onSuccess) {
        addNotification(response.message, NOTIFICATION_TYPE.ERROR, 'Thành công!')
        yield payload.onSuccess()
      }
    } else {
      if (payload.onError) {
        addNotification(response.message, NOTIFICATION_TYPE.ERROR, 'Không thành công!')
        yield payload.onError()
      }
    }
  } catch (error) {
    if (payload.onError) {
      addNotification('Quý khách vui lòng thử lại sau.', NOTIFICATION_TYPE.ERROR,  'Có lỗi xảy ra!')
      yield payload.onError()
    }
    yield put(createOrderFailed(error))
  }
}

export function* watchDoCheckIn() {
  yield takeLatest(CHECK_IN, doCheckIn)
}